import type { ReactNode } from 'react';
import { NotificationCenter } from '../features/notifications/NotificationCenter';
import type { AppNotification, NotificationActionTarget } from '../types';

const nav = [
  { key: 'home', label: 'Home', icon: 'H' },
  { key: 'records', label: 'Transactions', icon: 'T' },
  { key: 'add', label: 'Add Transaction', icon: '+' },
  { key: 'upcoming', label: 'Plans', icon: 'P' },
  { key: 'health', label: 'Health', icon: '!' },
  { key: 'reports', label: 'Reports', icon: 'R' },
  { key: 'setup', label: 'Settings', icon: 'S' }
] as const;

export type PageKey = typeof nav[number]['key'] | 'monthlyClose';

export function AppShell({ page, onPage, children, onLogout, notifications, unreadCount, notificationsLoading = false, notificationCenterOpen, onNotificationCenterOpenChange, onNotificationRead, onNotificationsReadAll, onNotificationDismiss, onNotificationsRefresh }: {
  page: PageKey;
  onPage: (p: PageKey) => void;
  children: ReactNode;
  onLogout: () => void;
  notifications: AppNotification[];
  unreadCount: number;
  notificationsLoading?: boolean;
  notificationCenterOpen?: boolean;
  onNotificationCenterOpenChange?: (open: boolean) => void;
  onNotificationRead: (id: string) => Promise<unknown>;
  onNotificationsReadAll: () => Promise<unknown>;
  onNotificationDismiss: (item: AppNotification) => Promise<unknown>;
  onNotificationsRefresh: () => Promise<unknown>;
}) {
  const openNotificationTarget = (target: NotificationActionTarget) => onPage(target);
  return <div className="app-shell">
    <aside className="desktop-sidebar">
      <div className="side-brand"><div className="brand-mark">PFS</div><div><b>SG-PFS</b><span>Finance System</span></div></div>
      <button className="side-primary" onClick={() => onPage('add')}>+ Add Transaction</button>
      <nav>{nav.filter((item) => item.key !== 'add').map((item) => <button key={item.key} className={page === item.key ? 'active' : ''} onClick={() => onPage(item.key)}><i>{item.icon}</i><span>{item.label}</span></button>)}</nav>
    </aside>
    <header className="topbar">
      <div className="brand-mark">PFS</div>
      <div className="brand-copy"><b>Personal Finance</b><span>Secure Firebase workspace</span></div>
      <div className="top-actions"><NotificationCenter notifications={notifications} unreadCount={unreadCount} loading={notificationsLoading} open={notificationCenterOpen} onOpenChange={onNotificationCenterOpenChange} onRead={onNotificationRead} onReadAll={onNotificationsReadAll} onDismiss={onNotificationDismiss} onAction={openNotificationTarget} onRefresh={onNotificationsRefresh} /><button className="top-action" onClick={onLogout}>Sign out</button></div>
    </header>
    <main>{children}</main>
    <nav className="bottom-nav">
      {[
        { key: 'home', label: 'Home', icon: 'H' },
        { key: 'records', label: 'Transactions', icon: 'T' },
        { key: 'add', label: 'Add', icon: '+' },
        { key: 'upcoming', label: 'Plans', icon: 'P' },
        { key: 'health', label: 'Health', icon: '!' },
        { key: 'reports', label: 'Reports', icon: 'R' }
      ].map((item) => <button key={item.key} className={page === item.key ? 'active' : ''} onClick={() => onPage(item.key as PageKey)}><i>{item.icon}</i><span>{item.label}</span></button>)}
    </nav>
  </div>;
}
